import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import PropTypes from "prop-types";

const tableSearchFieldSx = {
  minWidth: 400,
  "& .MuiOutlinedInput-input": {
    paddingLeft: "0px !important",
    paddingTop: "8px !important",
    paddingBottom: "8px !important",
  },
  "& .MuiOutlinedInput-root": {
    paddingLeft: "8px !important",
  },
  "& .MuiInputBase-input": {
    fontSize: "0.9rem",
    py: 1.2,
    width: "100% !important",
    paddingLeft: "0px !important",
  },
};

function TableSearchField({ placeholder, value, onChange }) {
  return (
    <TextField
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      variant="outlined"
      size="small"
      sx={tableSearchFieldSx}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={{ marginRight: "0px" }}>
            <i className="ni ni-zoom-split" />
          </InputAdornment>
        ),
      }}
    />
  );
}

TableSearchField.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TableSearchField;
